import { SET_SAVE_FUNCTION,NAVIGATION, SHOW_MENU, SHOW_ORDER_MANAGEMENT, GET_HEIGHT, HEADER_NAV } from './types'
const initialState = {
  nav: 'Home',
  height: null,
  showOrder: false,
  showMenu: false,
  headerNav: 'Home'
}

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case NAVIGATION:
      return {
        ...state,
        nav: action.payload,
      }
      case SET_SAVE_FUNCTION:
        return {
          ...state,
          saveFunction: action.payload,
        }
    case GET_HEIGHT:
      return {
        ...state,
        height: action.payload,
      }
    case SHOW_ORDER_MANAGEMENT:
      return {
        ...state,
        showOrder: action.payload
      }
    case SHOW_MENU:
      return {
        ...state,
        showMenu: true
      }
    case HEADER_NAV:
      return {
        ...state,
        headerNav: action.payload,
      }
    default: return state
  }
}

export default reducer
